"use client";

import { Image } from "@nextui-org/react";
import { useState } from "react";

export default function CopyButton({
  codeSnippet,
  copiedLabel,
  copyLabel,
  ...props
}: { codeSnippet: string, copiedLabel?: React.ReactNode, copyLabel?: React.ReactNode } & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (codeSnippet: string) => {
    try {
      await navigator.clipboard.writeText(codeSnippet);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <button
      type="button"
      onClick={() => copyToClipboard(codeSnippet)}
      {...props}
    >
      {isCopied ? (
        <>
          {
            copiedLabel ? copiedLabel : <>
              <Image
                src="/assets/images/checkmark-outline.svg"
                alt="Copied"
                width={16}
                height={16}
                className="rounded-none"
              />
              Copied
            </>
          }
        </>
      ) : (
        <>
          {
            copyLabel ? copyLabel : <>
              <Image
                src="/assets/images/copy-outline.svg"
                alt="Copy"
                width={16}
                height={16}
                className="rounded-none"
              />
              Copy
            </>
          }

        </>
      )}
    </button>
  );
}
